import React, { useState } from "react";
import { Copy, Check, Terminal } from "lucide-react";

const CODE = `curl -X POST https://api.etelecom.in/v1/sms/send \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "sender_id": "ETELCM",
    "to": ["+919852805552"],
    "type": "transactional",
    "message": "Your OTP is 481920. Valid for 10 minutes."
  }'`;

/**
 * Code editor style API snippet card with copy button.
 */
export const ApiSnippet = () => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CODE);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {}
  };
  const lines = CODE.split("\n");
  return (
    <div className="rounded-2xl bg-[#071427] border border-white/10 shadow-[0_18px_60px_rgba(2,6,23,0.35)] overflow-hidden" data-testid="bulk-sms-api-snippet">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-white/10">
        <Terminal className="h-4 w-4 text-slate-400" />
        <span className="text-xs font-mono text-slate-400">send_sms.sh</span>
        <button
          onClick={copy}
          aria-label="Copy code"
          className="ml-auto inline-flex items-center gap-1.5 rounded-lg bg-white/5 px-2.5 py-1 text-[11px] font-medium text-slate-300 hover:bg-white/10 transition-colors"
        >
          {copied ? <><Check className="h-3.5 w-3.5 text-green-400" /> Copied</> : <><Copy className="h-3.5 w-3.5" /> Copy</>}
        </button>
      </div>
      <pre className="overflow-x-auto p-4 text-[12px] sm:text-[13px] leading-relaxed font-mono">
        <code>
          {lines.map((ln, i) => (
            <div key={i} className="flex">
              <span className="select-none w-7 shrink-0 text-slate-600 text-right pr-3">{i + 1}</span>
              <span className="text-slate-200 whitespace-pre">{ln}</span>
            </div>
          ))}
        </code>
      </pre>
    </div>
  );
};
